import React, { useState, useEffect } from "react";
import Select from "react-select";
import Capsule from "../../common/components/Capsule";
import TimeField from "react-simple-timefield";
import moment from "moment";
import isEmpty from "lodash.isempty";
import produce from "immer";
import searchIcon from "../../assets/icons/icon-search.svg";
import { Calendar } from "primereact/calendar";
import { InputSwitch } from "primereact/inputswitch";
import FileIcon from "../../assets/icons/file.svg";
import PlaneIcon from "../../assets/icons/plane.svg";
import { changeCursorPosition } from "../../lib/helper";
import useTranslation from "../../i18n/useTranslation";
import { formatDateWithWeekdayMin, PRIME_DATE_FORMAT_WITH_DAY } from "../../i18n/dates";

export default function Transfer(props) {
   const { t, locale } = useTranslation();
   const { data, handleDestroy, allTasks, handleChange, allUsers, transferList } = props;
   const [transferNames, setTransferNames] = useState([]);
   const [transfersVisibility, setTransfersVisibility] = useState(false);
   const [transferDetails, setTransferDetails] = useState({
      data: "",
      godzinaOd: "",
      transferHotele: []
   });
   const [timeFieldData, setTimeFieldData] = useState({ display: false, hotelId: "" });
   const [filteredHotels, setFilteredHotels] = useState([]);
   const [searchInputValue, setSearchInputValue] = useState("");
   const [showOnlyCheckedHotels, setShowOnlyCheckedHotels] = useState(false);
   const [transferData, setTransferData] = useState({});

   useEffect(() => {
      generateTransferNames();
      //eslint-disable-next-line
   }, [transferList]);

   useEffect(() => {
      if (!data.dane.trasaWCId || isEmpty(transferList)) return;
      const transferData = transferList.find(
         (element) => element.trasaWCId === data.dane.trasaWCId
      );
      if (!transferData) return;
      setTransferDetails(transferData.transferyKlientow);
      setTransferData(transferData);
      //eslint-disable-next-line
   }, []);

   const handleTaskSelect = (selectedTask) => {
      const nextData = produce(data, (draft) => {
         draft.typ = selectedTask.value;
      });
      handleChange(nextData, true);
   };

   const generateTransferNames = () => {
      const names = transferList.map((transfer) => {
         let label = transfer.nazwaTrasy;
         if (transfer.numerLotu) label += ` [${transfer.numerLotu}]`;
         return { value: transfer.trasaWCId, label };
      });
      setTransferNames(names);
   };

   const addUser = (user) => {
      const nextData = produce(data, (draft) => {
         draft.uzytkownicy.push(user);
      });
      handleChange(nextData);
   };

   const removeAssignedUser = (id) => {
      const nextData = produce(data, (draft) => {
         draft.uzytkownicy = draft.uzytkownicy.filter((user) => user.id !== id);
      });
      handleChange(nextData);
   };

   const availableUsers = () => {
      const userIds = data.uzytkownicy.map((user) => user.id);
      return allUsers.filter((user) => !userIds.includes(user.id));
   };

   const handleTransferChange = (transfer) => {
      const nextData = produce(data, (draft) => {
         const transferData = transferList.find((element) => element.trasaWCId === transfer.value);
         draft.dane.transferyKlientow = { data: "", godzinaOd: "", transferHotele: [] };
         draft.dane.trasaWCId = transfer.value;
         draft.dane.nazwaTrasy = transferData.nazwaTrasy;
         if (transferData.numerLotu) draft.dane.numerLotu = transferData.numerLotu;
         draft.dane.dataTrasyWC = transferData.dataTrasyWC;
         draft.dane.dataWylotu = transferData.dataWylotu;
         draft.dane.transferyKlientow.data = transferData.transferyKlientow.data;
         draft.dane.transferyKlientow.godzinaOd = transferData.transferyKlientow.godzinaOd;
         setTransferDetails(transferData.transferyKlientow);
         setTransferData(transferData);
      });
      handleChange(nextData);
   };

   const handleInput = (ev) => {
      const nextData = produce(data, (draft) => {
         draft.dane[ev.target.id] = ev.target.value;
      });
      handleChange(nextData);
   };

   const handleHotelCheckbox = (transfer, isChecked) => {
      let { transferHotele } = data.dane.transferyKlientow;
      const nextData = produce(data, (draft) => {
         if (isChecked) {
            draft.dane.transferyKlientow.transferHotele = transferHotele.filter(
               (object) => object.hotel.id !== transfer.hotel.id
            );
         } else {
            draft.dane.transferyKlientow.transferHotele.push({
               hotel: transfer.hotel,
               godzinaZbiorki: "",
               miejsceZbiorki: transfer.miejsceZbiorki,
               dataZbiorki: data.dane.dataWylotu,
               uwagi: ""
            });
         }
      });
      handleChange(nextData);
   };

   const handleHotelData = (id, ev) => {
      const nextData = produce(data, (draft) => {
         draft.dane.transferyKlientow.transferHotele.forEach((object) => {
            if (object.hotel.id !== id) return;
            object[ev.target.id] = ev.target.value;
         });
      });
      handleChange(nextData);
   };

   const handleHotelHourChange = (event, value) => {
      const nextData = produce(data, (draft) => {
         draft.dane.transferyKlientow.transferHotele.forEach((object) => {
            if (object.hotel.id !== timeFieldData.hotelId) return;
            object.godzinaZbiorki = value;
         });
      });
      handleChange(nextData);
   };

   const handleHotelDateChange = (e) => {
      const nextData = produce(data, (draft) => {
         draft.dane.transferyKlientow.transferHotele.forEach((object) => {
            if (object.hotel.id !== e.target.id) return;
            object.dataZbiorki = moment(e.value).format("YYYY-MM-DD");
         });
      });
      handleChange(nextData);
   };

   const handleSearchInputChange = (e) => {
      const hotele = transferDetails.transferHotele.filter((hotel) =>
         hotel.hotel.nazwa.toLowerCase().includes(e.target.value.toLowerCase())
      );
      setSearchInputValue(e.target.value);
      setFilteredHotels({
         ...transferDetails,
         transferHotele: hotele
      });
   };

   const handleCheckedHotelsState = (e) => {
      setShowOnlyCheckedHotels(e.value);
   };

   const hotelsList =
      filteredHotels.transferHotele && filteredHotels.transferHotele.length > 0
         ? filteredHotels.transferHotele
         : transferDetails.transferHotele;

   const checkedHotelsList = showOnlyCheckedHotels
      ? hotelsList.filter((hotel) =>
           data.dane.transferyKlientow.transferHotele.find(
              (object) => object.hotel.id === hotel.hotel.id
           )
        )
      : hotelsList;
   
   const handleDisplayTimeField = async (e, hotelId) => {
      await setTimeFieldData({
         display: true,
         hotelId: hotelId
      })
      document.getElementById(e.target.name) && document.getElementById(e.target.name).click();
   }
   
   return (
      <div className="margin--bottom">
         <form id={`form-${data.id}`} className="form margin--top form-child">
            <span onClick={() => handleDestroy(data.id)} className="icon icon-close_icon"></span>
            <Select
               value={allTasks.find((option) => option.value === data.typ)}
               options={allTasks}
               placeholder={t("taskForms.selectTask")}
               onChange={handleTaskSelect}
               isClearable={false}
            />
            <div className="margin--top">
               <Select
                  value={transferNames.find((option) => option.value === data.dane.trasaWCId)}
                  options={transferNames}
                  placeholder={t("taskForms.selectTransfer")}
                  onChange={handleTransferChange}
                  clearable={false}
               />
            </div>
            <div
               className="margin--top"
               style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}
            >
               <span className="margin--bottom">{t("taskForms.assigned")}</span>
               {data.uzytkownicy.map((user) => (
                  <Capsule
                     key={user.id}
                     className="margin--left margin--bottom"
                     id={user.id}
                     text={user.imieNazwisko}
                     onRemove={removeAssignedUser}
                  />
               ))}
               <Select
                  options={availableUsers()}
                  value={null}
                  className="margin--left margin--bottom col-4 padding--remove"
                  placeholder={t("taskForms.addPerson")}
                  onChange={addUser}
               />
            </div>
            <div>
               <textarea
                  id="uwagi"
                  rows={5}
                  value={data.dane.uwagi}
                  placeholder={t("taskForms.notes")}
                  onChange={handleInput}
               />
            </div>
         </form>
         <div className={`text-center ${!data.dane.trasaWCId && "display_hidden"}`}>
            <button
               onClick={() => setTransfersVisibility(!transfersVisibility)}
               className="button__transparent button__rounded button__medium margin--top"
            >
               {transfersVisibility
                  ? t("taskForms.hideClientTransfers")
                  : t("taskForms.showClientTransfers")}
            </button>
         </div>
         <div
            className={`order__trips--panel margin--top transfer-container ${
               !transfersVisibility && "display_hidden"
            }`}
         >
            <div>
               <div className="trips__box">
                  <div className="trips__single order__trips--single">
                     <div className="trips__header trips__header--order highlighted header flex-wrap h-auto">
                        {t("taskForms.clientTransfers")}
                        <div className="search-container input-group col-xs-12 col-sm-4 p-0">
                           <span className="input-group-append">
                              <div className="search-icon input-group-text bg-transparent border-right-0">
                                 <img src={searchIcon} alt="search-icon" />
                              </div>
                           </span>
                           <input
                              onChange={handleSearchInputChange}
                              className="search-input form-control bg-transparent border-left-0 shadow-none py-1 pl-0 pr-1"
                              type="search"
                           />
                        </div>
                     </div>
                     <div className="trips__info highlighted details py-1">
                        {transferData.dataWylotu === transferData.dataTrasyWC ? (
                           <div className="flex flex-column">
                              <div className="flex align-items-center">
                                 <img
                                    src={FileIcon}
                                    className="trips__info--icon mr-2"
                                    alt="file-icon"
                                 />
                                 <img
                                    src={PlaneIcon}
                                    className="trips__info--icon mr-2"
                                    alt="plane-icon"
                                 />
                                 {formatDateWithWeekdayMin(transferData.dataWylotu, locale)}
                              </div>
                           </div>
                        ) : (
                           <div className="flex flex-column justify-content-beetwen mt-1">
                              <div className="flex align-items-center">
                                 <img
                                    src={PlaneIcon}
                                    className="trips__info--icon mr-2"
                                    alt="plane-icon"
                                 />
                                 {formatDateWithWeekdayMin(transferData.dataWylotu, locale)}
                              </div>
                              <div className="flex align-items-center">
                                 <img
                                    src={FileIcon}
                                    className="trips__info--icon mr-2"
                                    alt="file-icon"
                                 />
                                 {formatDateWithWeekdayMin(transferData.dataTrasyWC, locale)}
                              </div>
                           </div>
                        )}
                        <div className="flex flex-column justify-content-beetwen mt-1">
                           <span>
                              {t("taskForms.selectedHotelsCount")}
                              <span className="text-bold">
                                 {` ${
                                    data.dane.transferyKlientow.transferHotele &&
                                    data.dane.transferyKlientow.transferHotele.length
                                 }/${transferDetails.transferHotele.length}`}
                              </span>
                           </span>
                           <span className="flex align-items-center">
                              {t("taskForms.showOnlySelectedHotels")}
                              <InputSwitch
                                 checked={showOnlyCheckedHotels}
                                 onChange={handleCheckedHotelsState}
                                 className="ml-1"
                              />
                           </span>
                        </div>
                     </div>
                     {searchInputValue && filteredHotels.transferHotele.length === 0 ? (
                        <div className="hotel-header text-danger">
                           {t("taskForms.noResultsFor", { query: searchInputValue })}
                        </div>
                     ) : (
                        checkedHotelsList.map((transfer, i) => {
                           const transferData =
                              data.dane.transferyKlientow.transferHotele.find(
                                 (object) => object.hotel.id === transfer.hotel.id
                              ) || {};
                           const isChecked = transferData.hotel ? true : false;
                           return (
                              <div
                                 key={`${data.id}-${transfer.hotel.id}`}
                                 className="order__trips--body"
                              >
                                 <div
                                    className={`hotel-header ${
                                       isChecked && "hotel-header__active"
                                    }`}
                                 >
                                    <span>{transfer.hotel.nazwa}</span>
                                    <div className="hotel-header__calendar-checkbox flex align-items-center">
                                       <Calendar
                                          value={
                                             isChecked
                                                ? new Date(transferData.dataZbiorki)
                                                : new Date(data.dane.dataWylotu)
                                          }
                                          onChange={(e) => handleHotelDateChange(e, isChecked)}
                                          disabled={!isChecked}
                                          id={transfer.hotel.id}
                                          showIcon
                                          dateFormat={PRIME_DATE_FORMAT_WITH_DAY}
                                          className="text-xs mr-2"
                                          locale={locale}
                                          readOnlyInput={true}
                                       />

                                       <div className="custom-checkbox">
                                          <input
                                             type="checkbox"
                                             checked={isChecked}
                                             id={`${data.id}-${transfer.hotel.id}`}
                                             onChange={() =>
                                                handleHotelCheckbox(transfer, isChecked)
                                             }
                                          />
                                          <label htmlFor={`${data.id}-${transfer.hotel.id}`} />
                                       </div>
                                    </div>
                                 </div>
                                 <div className="row hotel-data form">
                                    <div className="col-3 padding--remove__right position-relative">
                                       {timeFieldData.display &&
                                       timeFieldData.hotelId === transfer.hotel.id ? (
                                          <TimeField
                                             className="hour-input"
                                             value={data.dane.godzOd || "00:00"}
                                             onChange={handleHotelHourChange}
                                             onClick={changeCursorPosition}
                                             id={`godzinaZbiorki ${transfer.hotel.id}`}
                                             autoFocus
                                          />
                                       ) : (
                                          <input
                                             className="hour-input"
                                             autoComplete="off"
                                             readOnly
                                             id="godzinaZbiorki"
                                             name={`godzinaZbiorki ${transfer.hotel.id}`}
                                             placeholder={t("taskForms.meetingTime")}
                                             value={isChecked ? transferData.godzinaZbiorki : ""}
                                             type="text"
                                             onClick={(e) =>
                                                isChecked &&
                                                handleDisplayTimeField(e, transfer.hotel.id)
                                             }
                                             style={{ border: !transferData.godzinaZbiorki && isChecked ? '1px solid red' : undefined }}
                                             required={isChecked}
                                          />
                                       )}
                                    </div>
                                    <div className="col-3 padding--remove__right">
                                       <input
                                          id="miejsceZbiorki"
                                          placeholder={t("taskForms.meetingPoint")}
                                          disabled={!isChecked}
                                          value={isChecked ? transferData.miejsceZbiorki : ""}
                                          onChange={(ev) => handleHotelData(transfer.hotel.id, ev)}
                                          className="select-input"
                                          style={{ border: !transferData.miejsceZbiorki && isChecked ? '1px solid red' : undefined }}
                                          required={isChecked}
                                       />
                                    </div>
                                    <div className="col-6">
                                       <input
                                          id="uwagi"
                                          placeholder={t("taskForms.notes")}
                                          disabled={!isChecked}
                                          value={isChecked ? transferData.uwagi : ""}
                                          onChange={(ev) => handleHotelData(transfer.hotel.id, ev)}
                                          className="select-input"
                                       />
                                    </div>
                                 </div>
                              </div>
                           );
                        })
                     )}
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
}
